<template>
  <div
    v-if="oneDayVacancies.length > 0"
    class="suggestions"
  >
    <div class=" max-width-container">
      <h2 class="mb-4">{{ title }}</h2>
      <div class="slider-suggestion-wrapper">
        <HtmlSlider
          v-if="oneDayVacancies.length > 0"
          :show-arrows="false"
          :show-bullets="false"
          :slides-to-show="3"
        >
          <div
            v-for="oneDayVacancy in oneDayVacancies"
            :key="oneDayVacancy.id"
          >
            <LazySearchOneDayVacancyTileResult
              :one-day-vacancy="oneDayVacancy"
              style="max-width: 20rem;"
            />
          </div>
        </HtmlSlider>
      </div>

      <b-button
        v-if="showButton"
        @click="searchOneDayVacancies"
      >
        {{ $gadTranslateUpper(buttonTextKey) }}
      </b-button>
    </div>
  </div>
</template>

<script setup>
const nuxtApp = useNuxtApp()

const props = defineProps({
  oneDayVacancies: {
    type: Array,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  showButton: {
    type: Boolean,
    default: false,
  },
  buttonTextKey: {
    type: String,
    default: 'general_button_show_all',
  },
})

const searchOneDayVacancies = () => {
  nuxtApp.$router.push(nuxtApp.$findPath('/eendags-vrijwilligerswerk-zoeken'))
}

</script>

<style lang="scss" scoped>
@import '~assets/styles/variables/colors';
@import '~assets/styles/variables/sizes';
@import '~assets/styles/variables/spacing';

.suggestions {
  margin: 75px -30px -60px -30px;
  padding: 50px;
  background: url("~assets/images/general/left-corner-visual.svg") bottom left no-repeat;
  background-color: $light-gray;

  :deep(.slider-suggestion-wrapper) {
    .tile-result {
      padding-right: 20px;

      .p-card {
        box-shadow: none;
      }

      h4 {
        overflow: hidden;
      }
    }

    .icon-selection {
      > .icons-container {
        .base-icon {
          width: 64px;
        }
      }
    }
  }

  button {
    margin: auto;
    display: block;
  }
}

@media (max-width: $mobile-width) {
  .suggestions {
    margin-top: $space;
  }
}

</style>
